export const GET_KEY = 'secondAuth.GET_KEY';
export const VALIDATE_KEY = 'secondAuth.VALIDATE_KEY';
export const CLEAR_SECOND_AUTH = 'secondAuth.CLEAR_SECOND_AUTH';